import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  Drawer,
  FormControlLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Euro, KingBed } from "@mui/icons-material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import { ManagePropertyContext } from "../../pages/myProperty";

function FilterOwnProperty() {
  const formatNumberWithDots = (number) => {
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };
  const handleChange = (value) => {
    const rawValue = value.replace(/\./g, "");
    return rawValue;
  };

  const {
    handlerResetFilters,
    handlerFilterSet,
    openDrawer,
    toggleDrawer,
    expanded,
    handlerChangeExpanded,
    filtersSettings,
    setFiltersSettings,
    locationList,
  } = useContext(ManagePropertyContext);
  return (
    <Drawer open={openDrawer} anchor="right" onClose={toggleDrawer(false)}>
      <Stack
        sx={{
          px: 2,
          py: 1,
          width: { xs: 270, md: 330 },
          position: "relative",
          height: "100%",
        }}
      >
        <Typography component="h2" variant="h5" mb={3}>
          Filtros
        </Typography>
        <Accordion
          sx={{ mb: 2 }}
          expanded={expanded === "panel1"}
          onChange={handlerChangeExpanded("panel1")}
        >
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <Typography
              component="h3"
              variant="h6"
              display="flex"
              alignItems="center"
              gap={1}
            >
              <AttachMoneyIcon />
              Precio
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Stack>
              <TextField
                aria-label="Input-min-price"
                label="Minimo"
                type="text"
                autoComplete="off"
                value={formatNumberWithDots(filtersSettings.price.min)}
                onChange={({ target }) => {
                  let result = handleChange(target.value);
                  setFiltersSettings({
                    ...filtersSettings,
                    price: {
                      ...filtersSettings.price,
                      min: result,
                    },
                  });
                }}
                sx={{
                  mb: 2,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Euro fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                aria-label="Input-max-price"
                label="Máximo"
                type="text"
                autoComplete="off"
                value={formatNumberWithDots(filtersSettings.price.max)}
                onChange={({ target }) => {
                  let result = handleChange(target.value);
                  setFiltersSettings({
                    ...filtersSettings,
                    price: {
                      ...filtersSettings.price,
                      max: result,
                    },
                  });
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Euro fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            </Stack>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handlerChangeExpanded("panel2")}
          sx={{ mb: 2 }}
        >
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <Typography
              component="h3"
              variant="h6"
              display="flex"
              alignItems="center"
              gap={1}
            >
              <FmdGoodIcon />
              Ubicación
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Autocomplete
              value={filtersSettings.location}
              disablePortal
              onChange={(e) => {
                if (e.target.innerHTML.includes("<path")) {
                  setFiltersSettings({
                    ...filtersSettings,
                    location: "",
                  });
                } else {
                  setFiltersSettings({
                    ...filtersSettings,
                    location: e.target.innerHTML,
                  });
                }
              }}
              id="combo-box-demo"
              options={locationList}
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <TextField {...params} label="Ubicación" />
              )}
            />
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{ mb: 2 }}
          expanded={expanded === "panel3"}
          onChange={handlerChangeExpanded("panel3")}
        >
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <Typography
              component="h3"
              variant="h6"
              display="flex"
              alignItems="center"
              gap={1}
            >
              <MapsHomeWorkIcon />
              Tipo de inmueble
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Stack flexDirection="row">
              <RadioGroup
                name="use-radio-group"
                value={filtersSettings.type}
                onChange={({ target }) => {
                  setFiltersSettings({
                    ...filtersSettings,
                    type: target.value,
                  });
                }}
              >
                <FormControlLabel
                  value="all"
                  label="Todos"
                  control={<Radio />}
                />
                <FormControlLabel
                  value="Casa"
                  label="Casas"
                  control={<Radio />}
                />
                <FormControlLabel
                  value="Apartamento"
                  label="Apartamentos"
                  control={<Radio />}
                />
              </RadioGroup>
            </Stack>
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{ mb: 2 }}
          expanded={expanded === "panel4"}
          onChange={handlerChangeExpanded("panel4")}
        >
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <Typography
              component="h3"
              variant="h6"
              display="flex"
              alignItems="center"
              gap={1}
            >
              <KingBed />
              Habitaciones
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Stack>
              <TextField
                aria-label="Input-min-rooms"
                label="Minimo"
                type="number"
                autoComplete="off"
                value={filtersSettings.rooms.min}
                onChange={({ target }) => {
                  setFiltersSettings({
                    ...filtersSettings,
                    rooms: {
                      ...filtersSettings.rooms,
                      min: parseInt(target.value),
                    },
                  });
                }}
                sx={{
                  mb: 2,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <KingBed fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                aria-label="Input-max-rooms"
                label="Máximo"
                type="number"
                autoComplete="off"
                value={filtersSettings.rooms.max}
                onChange={({ target }) => {
                  setFiltersSettings({
                    ...filtersSettings,
                    rooms: {
                      ...filtersSettings.rooms,
                      max: parseInt(target.value),
                    },
                  });
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <KingBed fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
            </Stack>
          </AccordionDetails>
        </Accordion>
        {/* BOTONES DE ACCIÓN */}
        <Stack flexDirection="row" position="absolute" width="90%" bottom={10}>
          <Button
            sx={{ width: "50%", color: "white", marginRight: 1 }}
            variant="contained"
            onClick={handlerFilterSet}
          >
            APLICAR
          </Button>
          <Button sx={{ width: "50%" }} onClick={handlerResetFilters}>
            RESTABLECER
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
}

export default FilterOwnProperty;
